let imgHref
if (window.location.href.split('/')[2] === 'localhost:8080') {
    imgHref = "https://cdp-local-web.test.routeryuncs.com/"
} else if (window.location.href.split('/')[2] === '10.10.0.187:8080') {
    imgHref = "https://cdp-local-web.test.routeryuncs.com/"
} else {
    imgHref = location.protocol + '//' + window.location.href.split('/')[2] + '/'
}
export const picPrefix = imgHref